import { Result } from 'antd';
import React from 'react';

export const PermissionDenied = () => {
  return (
    <Result
      status="403"
      title="403"
      subTitle="Sorry, you are not authorized to access this page."
      // extra={
      //   <Link to="/" className="link-home">
      //     <Button type="primary">Back Home</Button>
      //   </Link>
      // }
    />
  );
};
